import { useUser } from "../functional-components/UserContext";
import { siteVatFactor } from "../utils/VatUtils";

const useShowPricesWithVat = b2b => {
  const { b2b: userB2b } = useUser();
  return !b2b && !userB2b && siteVatFactor > 1.0;
};

export default useShowPricesWithVat;
